<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 652 652"
    style="enable-background: new 0 0 652 652"
    xml:space="preserve"
    height="130"
  >
    <path
      class="st0"
      d="M158.2,327c-2.8,2.8-7.7,4.2-14.5,4.2c-1.4,0-2.9-0.1-4.3-0.2c-1.5-0.1-2.7-0.3-3.8-0.5v-28.9
	c0.9-0.4,2.2-0.7,3.9-1c1.6-0.3,3.5-0.5,5.5-0.5c6.2,0,10.7,1.3,13.4,4c2.7,2.6,4.1,6.5,4.1,11.6C162.4,320.3,161,324.1,158.2,327
	 M169,299.2c-2.5-2.1-5.7-3.7-9.6-4.9c-3.9-1.2-8.6-1.8-14-1.8c-4.7,0-9.1,0.4-13.2,1.2c-4.1,0.8-7.6,1.8-10.4,3v71h13.9V338
	c1,0.1,2.3,0.3,3.9,0.4c1.6,0.1,3.1,0.2,4.6,0.2c5.7,0,10.6-0.6,14.7-1.8c4.1-1.2,7.4-2.8,10-4.9c2.6-2.1,4.5-4.5,5.7-7.3
	c1.2-2.8,1.8-5.8,1.8-8.9c0-3.3-0.6-6.3-1.8-9.2C173.3,303.7,171.5,301.2,169,299.2"
    />
    <path
      class="st0"
      d="M200.6,289.1c-1.5-1.3-3.4-1.9-5.5-1.9c-2.1,0-4,0.6-5.5,1.9c-1.5,1.3-2.3,2.8-2.3,4.6s0.8,3.3,2.3,4.6
	c1.5,1.3,3.4,1.9,5.5,1.9c2.1,0,4-0.6,5.5-1.9c1.5-1.3,2.3-2.8,2.3-4.6S202.2,290.3,200.6,289.1"
    />
    <rect
      x="188.4"
      y="310"
      class="st0"
      width="13.5"
      height="57.7"
    />
    <path
      class="st0"
      d="M235.6,293.6l-13.3,3.4v13h-8.8v7.5h8.8v35.9c0,1.9,0.3,3.8,1,5.7c0.7,1.9,1.7,3.6,3.1,5
	c1.4,1.5,3.3,2.6,5.6,3.5c2.3,0.9,5.1,1.3,8.4,1.3c1.7,0,3.2-0.1,4.5-0.4c1.3-0.3,2.2-0.5,2.9-0.8v-7.7c-0.6,0.1-1.3,0.3-1.8,0.4
	c-0.6,0.1-1.2,0.2-1.8,0.2c-2.9,0-5-0.8-6.4-2.3c-1.4-1.5-2.1-3.4-2.1-5.7v-35.2h12.2V310h-12.2V293.6z"
    />
    <path
      class="st0"
      d="M290.5,359.5c-1.6,0.6-3.5,0.9-5.6,0.9c-2.5,0-4.8-0.5-6.7-1.6c-2-1-3.7-2.5-5.2-4.4c-1.4-1.9-2.5-4.2-3.3-6.9
	c-0.8-2.7-1.2-5.7-1.2-8.9c0-6.5,1.4-11.7,4.2-15.7c2.8-4,6.9-6,12.4-6c2.3,0,4.2,0.3,5.9,0.9c1.6,0.6,3,1.2,4,1.9l3-7
	c-1.5-1.1-3.6-2-6.2-2.9c-2.6-0.9-5.9-1.3-9.9-1.3c-3.8,0-7.3,0.7-10.7,2c-3.3,1.4-6.2,3.3-8.7,6c-2.5,2.6-4.4,5.8-5.8,9.5
	c-1.4,3.7-2.1,8-2.1,12.8c0,4.7,0.7,8.9,2.1,12.7c1.4,3.8,3.3,6.9,5.7,9.6c2.4,2.6,5.3,4.7,8.6,6.1c3.3,1.4,6.9,2.1,10.8,2.1
	c4.1,0,7.4-0.4,10.1-1.3c2.7-0.9,4.7-1.8,6.2-2.9l-3.3-7.6C293.5,358.2,292.1,358.9,290.5,359.5"
    />
    <path
      class="st0"
      d="M353.5,314.2c-1.9-1.6-4.3-3-7.3-4c-3-1-6.6-1.5-10.9-1.5c-3.4,0-6.3,0.3-8.8,1c-2.5,0.7-4.7,1.4-6.6,2.2
	l-0.1-28.3h-13.3v84.1h13.3v-49.1c1.4-0.7,3.2-1.3,5.3-1.8c2.1-0.5,4.3-0.7,6.6-0.7c2.4,0,4.5,0.3,6.2,0.9c1.7,0.6,3.1,1.3,4.2,2.3
	c1.1,1,1.9,2.1,2.4,3.3c0.5,1.2,0.8,2.4,0.8,3.7v41.3h13.5v-41.6c0-2.1-0.4-4.3-1.2-6.4C356.7,317.7,355.4,315.8,353.5,314.2"
    />
    <path
      class="st0"
      d="M415.3,353.8c-0.9,1.8-2.2,3.2-3.8,4.3c-1.6,1.1-3.5,1.9-5.8,2.4c-2.3,0.5-4.7,0.7-7.3,0.7
	c-2.3,0-4.4-0.2-6.3-0.5c-1.9-0.4-3.5-0.8-4.8-1.3v-27c0.6-0.1,1.5-0.1,2.7-0.2c1.1,0,2.2-0.1,3.2-0.1c8.4,0,14.4,1.2,18,3.7
	c3.6,2.5,5.4,6.3,5.4,11.5C416.7,350,416.2,352.1,415.3,353.8 M387.4,301.4c1.4-0.5,3-0.9,4.7-1.2c1.7-0.3,3.6-0.4,5.7-0.4
	c11.1,0,16.6,4.3,16.6,12.8c0,2.2-0.4,4.2-1.1,5.9c-0.7,1.7-1.9,3.1-3.6,4.2c-1.7,1.1-3.9,2-6.5,2.5c-2.7,0.6-6,0.9-9.9,0.9
	c-1,0-2.1,0-3.2-0.1c-1.1,0-2-0.1-2.7-0.2V301.4z M424.5,334.7c-1.8-1.6-3.8-2.8-6.1-3.9c-2.2-1-4.3-1.7-6.3-2v-0.2
	c1.9-0.4,3.7-0.9,5.6-1.8c1.9-0.8,3.6-1.9,5.1-3.3c1.5-1.4,2.7-3,3.7-4.9c1-1.9,1.4-4.2,1.4-6.7c0-2.7-0.6-5.2-1.8-7.6
	c-1.2-2.3-3.1-4.4-5.6-6.2c-2.5-1.8-5.6-3.1-9.4-4.1c-3.8-1-8.3-1.5-13.4-1.5c-5.1,0-9.8,0.4-13.9,1.2c-4.1,0.8-7.5,1.8-10.1,2.9
	V365c2.7,1.2,6.2,2.2,10.5,3c4.3,0.8,9.1,1.2,14.5,1.2c4.8,0,9.2-0.4,13.1-1.3c4-0.9,7.4-2.2,10.2-3.9c2.8-1.7,5-4,6.5-6.7
	c1.5-2.7,2.3-5.9,2.3-9.6c0-2.7-0.6-5.2-1.8-7.3C427.8,338.2,426.3,336.3,424.5,334.7"
    />
    <path
      class="st0"
      d="M482,347c-0.5,2.6-1.3,5-2.5,7c-1.2,2-2.7,3.7-4.7,4.9c-1.9,1.2-4.3,1.9-7.2,1.9s-5.2-0.6-7.1-1.9
	c-1.9-1.3-3.4-2.9-4.6-4.9c-1.2-2-2-4.4-2.5-7c-0.5-2.6-0.8-5.4-0.8-8.1c0-2.8,0.2-5.5,0.7-8.2c0.5-2.7,1.3-5.1,2.5-7.2
	c1.2-2.1,2.7-3.7,4.6-5c1.9-1.3,4.3-1.9,7.2-1.9c2.9,0,5.3,0.6,7.2,1.9c1.9,1.3,3.5,3,4.7,5c1.2,2.1,2,4.5,2.5,7.2
	c0.5,2.7,0.7,5.5,0.7,8.2C482.7,341.7,482.5,344.4,482,347 M489.2,317.2c-2.4-2.7-5.4-4.9-8.9-6.4c-3.6-1.5-7.7-2.3-12.5-2.3
	s-9,0.8-12.6,2.3c-3.6,1.5-6.6,3.7-9,6.4c-2.4,2.7-4.2,6-5.4,9.7c-1.2,3.7-1.8,7.7-1.8,12c0,4.3,0.6,8.3,1.8,12
	c1.2,3.7,3,6.9,5.4,9.6c2.4,2.7,5.4,4.8,9,6.4c3.6,1.5,7.8,2.3,12.6,2.3s9-0.8,12.5-2.3c3.6-1.5,6.5-3.7,8.9-6.4
	c2.4-2.7,4.2-5.9,5.4-9.6c1.2-3.7,1.8-7.7,1.8-12c0-4.3-0.6-8.3-1.8-12C493.3,323.2,491.6,320,489.2,317.2"
    />
    <path
      class="st0"
      d="M547,347c-0.5,2.6-1.3,5-2.5,7c-1.2,2-2.7,3.7-4.7,4.9c-1.9,1.2-4.3,1.9-7.2,1.9c-2.9,0-5.2-0.6-7.1-1.9
	c-1.9-1.3-3.4-2.9-4.6-4.9c-1.2-2-2-4.4-2.5-7c-0.5-2.6-0.8-5.4-0.8-8.1c0-2.8,0.2-5.5,0.7-8.2c0.5-2.7,1.3-5.1,2.5-7.2
	c1.2-2.1,2.7-3.7,4.6-5c1.9-1.3,4.3-1.9,7.2-1.9c2.8,0,5.2,0.6,7.2,1.9c1.9,1.3,3.5,3,4.7,5c1.2,2.1,2,4.5,2.5,7.2
	c0.5,2.7,0.7,5.5,0.7,8.2C547.7,341.7,547.5,344.4,547,347 M554.2,317.2c-2.4-2.7-5.4-4.9-8.9-6.4c-3.6-1.5-7.7-2.3-12.5-2.3
	c-4.8,0-9,0.8-12.6,2.3c-3.6,1.5-6.6,3.7-9,6.4c-2.4,2.7-4.2,6-5.4,9.7c-1.2,3.7-1.8,7.7-1.8,12c0,4.3,0.6,8.3,1.8,12
	c1.2,3.7,3,6.9,5.4,9.6c2.4,2.7,5.4,4.8,9,6.4c3.6,1.5,7.8,2.3,12.6,2.3c4.8,0,9-0.8,12.5-2.3c3.6-1.5,6.5-3.7,8.9-6.4
	c2.4-2.7,4.2-5.9,5.4-9.6c1.2-3.7,1.8-7.7,1.8-12c0-4.3-0.6-8.3-1.8-12C558.4,323.2,556.6,320,554.2,317.2"
    />
    <polygon
      class="st0"
      points="597.8,335.1 623.6,310 609.4,310 585.2,335.1 585,335.1 585,283.6 571.7,283.6 571.7,367.7 585,367.7
	585,336.3 585.2,336.3 610.7,367.7 626.4,367.7 "
    />
    <path
      class="st0"
      d="M95.2,280.3c-53.6,4.3-75.8,47.5-66.9,74.7c5.2-7.8,14.8-16.2,34.5-19.3C61.6,312.8,70.2,296.7,95.2,280.3"
    />
    <path
      class="st0"
      d="M67.8,339c-13.5,2.2-23,5.8-28.9,11.2c0.2,7.2,2.2,14.2,6.2,20.5c4.6-10.9,19.6-18.6,42.5-18.7
	c-5.6-26.1,6.8-50,26.2-66.1c-10.4,1.6-19.7,4.1-27.9,7.3C71.1,307,65.6,324.8,67.8,339"
    />
  </svg>
</template>

<style scoped lang="css">
.st0 {
  fill: #426893;
}
</style>
